import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../StoryAndSourceChecker.ducks';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';
import themeable from 'zignal-landscape/lib/themeable';

const ICON_PROPS = {
  width: '1em',
  height: '1em',
};

export const mapStateToProps = (
  (state) => ({
    isFetching: state.StoryAndSourceChecker.isFetching,
    storyCheckerResults: state.StoryAndSourceChecker.storyCheckerResults
  })
);
export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class StoryContentMSIChecker extends Component {

  // call the standard Ducks for StoryAndSourceChecker to prepare and execute
  // a Source Checker 'content' query using the title and body from the Story
  // that we are being asked to import
  componentDidMount() {
    const {title, body, profiles, campaignId} = this.props;
    this.props.setSourceType('content');
    this.props.handleTitleChanged({target: {value : title}});
    this.props.editSourcesOrStoriesList({target: {value : body}});
    this.props.handleProfilesChange({
      value: profiles,
      profiles: []
    });
    this.props.fetchStoryCheckerResults(campaignId);
  }

  render() {
    const {storyCheckerResults, styles} = this.props;
    const anyMatch = storyCheckerResults && storyCheckerResults.length > 0
      ? storyCheckerResults.some((e)=> e.matchingProfileIds.length > 0) : true;
    const matchText = !anyMatch &&
      (
        <li key="included">
          <span className={styles.detailIconBlue}><InformationIcon {...ICON_PROPS} /></span>
          <span className={styles.detailAnalysisText}>
            <p>This story does not match any of the datasets in the workspace</p>
          </span>
        </li>
      );

    return (<div>
      {matchText}
    </div>);
  }
}

StoryContentMSIChecker.propTypes = {
  styles: PropTypes.object,
  title: PropTypes.string,
  body: PropTypes.string,
  campaignId: PropTypes.string,
  profiles: PropTypes.array,
  handleProfilesChange: PropTypes.func,
  handleTitleChanged: PropTypes.func,
  editSourcesOrStoriesList: PropTypes.func,
  fetchStoryCheckerResults: PropTypes.func,
  setSourceType: PropTypes.func,
  storyCheckerResults: PropTypes.array
};

StoryContentMSIChecker.defaultProps = {
  title: '',
  body: '',
  storyCheckerResults: Object.freeze([])
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(StoryContentMSIChecker));
